export const contactText = {
	_1: 'Get in touch',
	_2: 'Have a question or need some customization? Get in touch with us! '
}

export const contactCategories = {
	_1: {
	  title: 'Contact info',
	  subcategories: [
	    {
	  	  key: 0,
	  	  subtitle: 'Email',
	  	  text: 'info@aircheckr.com'
	    }
	  ]
	},
	_2: {
		title: 'Offices',
		subcategories: [
          {
          	key: 0,
          	subtitle: 'Office in Leuven',
          	text: 'Tiensevest 100, 3000 Leuven, Belgium'
          }
		]
	},
	_3: {
		title: 'Administrative Info',
		subcategories: [
          {
          	key: 0,
          	subtitle: 'Nazka Mapps',
          	text: 'aircheckr is a product of Nazka Mapps'
          },
          {
          	key: 1,
          	text: 'Check out our page',
	        linkAddress: 'http://nazka.be',
	        linkText: 'www.nazka.be',
             linkTarget: '_blank'
          },
          {
          	key: 2,
          	subtitle: 'Administrative seat',
          	text: 'Ravesteinstraat 48A, 3191 Hever, Belgium'
          },
          {
          	key: 3,
          	subtitle: 'VAT',
          	text: 'BE0500.452.197'
          },
          {
          	key: 4,
          	subtitle: 'Bank info',
          	'text': 'IBAN: BE94 3631 1161 5314; BIC: BBRUBEBB'
          }
		]
	}
}

export default contactText;



// WEBPACK FOOTER //
// ./src/input-text/en/contact_page.js